import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import arrowUp from "../../assets/icons/Up.svg";
import arrowDown from "../../assets/icons/down.svg";
import { useSelector } from 'react-redux';
import auth from '../../Helpers/auth'
import arrowRigth from "../../assets/icons/arrowRigth.svg";
import vectorLeft from "../../assets/icons/vectorLeft.svg";
import { Markup } from "interweave";
import Loader from "react-loader-spinner";
import CabezoteComponent from '../../Components/Cabezote/cabezote.component'
import Footer from '../../Components/Footer/Footer.components'
//axios
import axios from "axios";
//constantes
import * as Constant from "../../global/const";
import { useState, useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const Contenedor = () => {
  const [panel, setpanel] = useState("temas");
  const [temas, settemas] = useState([]);
  const [open, setOpen] = useState(false);
  const [close, setclose] = useState(true);
  const [Tema, setTema] = useState([]);
  const [Error, setError] = useState(null);
  const [busqueda, setbusqueda] = React.useState("");

  const getBusqueda = (term) => {
    setTema(null)
    settemas([])
    if (term.trim().length === 0) {
      getPreguntas()
      setError(null)
      return
    }
    axios
      .get(Constant.FAQS + "?busqueda=" + term)
      .then((response) => {
        setpanel('busqueda')
        if (response.data.length === 0) {
          setError('No hay resultados')
          return
        }
        setTema({
          preguntas: response.data
        })
        settemas(response.data);
        setError(null)
      })
      .catch((err) => {
        console.log("ERROR ", err);
      });
  };

  const getPreguntas = () => {
    setpanel("temas")
    axios
      .get(Constant.FAQS)
      .then((response) => {
        if (response.data.length == 0) {
          setError('No hay resultados')
          return
        }
        settemas(response.data);
        setTema([])
        setError(null)
      })
      .catch((err) => {
        console.log("ERROR ", err);
      });
  };

  useEffect(() => {
    getPreguntas();
  }, []);

  return (
    <div className="home">
      <CabezoteComponent
        open={open}
        setOpen={setOpen}
        tipo={false}
        categoriasGlobal={null}
        close={close}
        setclose={setclose}
      />
      <div className="ContainerFrecuentes">
        <div className="HeaderFrecuentes">
          {panel !== "temas" && temas.length !== 0 ? (
            <div className="HeaderLeft">
              <img src={vectorLeft} alt="" onClick={() => getPreguntas()} />
              <div className="cabezera_preguntasFrecuentes">
                <div>
                  <h1>Preguntas Frecuentes </h1>
                  <span> / {Tema.agrupador}</span>
                </div>
                <h2>Selecciona una pregunta</h2>
              </div>
            </div>
          ) : (
            <div className="HeaderLeft">
              <div>
                <h1>Preguntas Frecuentes</h1>
                <h2>Selecciona un tema</h2>
              </div>
            </div>
          )}
          <div className="HeaderRigth">
            <input
              type="text"
              placeholder="Buscar"
              onChange={(e) => getBusqueda(e.target.value)}
            />
            {panel !== "temas" && temas.length !== 0 ? (<h2 className="sub_movil">Selecciona una pregunta</h2>) : (<h2 className="sub_movil">Selecciona un tema</h2>)}
          </div>
        </div>
        {temas.length !== 0 && Tema != null ? (
          panel === "temas" ? (
            <Temas
              temas={temas}
              setpanel={setpanel}
              setTema={setTema}
              getBusqueda={getBusqueda}
              setbusqueda={setbusqueda}
              busqueda={busqueda}
            />
          ) : panel === "busqueda" ? (
            <PreguntasFrecuentes
              Tema={Tema}
              setpanel={setpanel}
              getBusqueda={getBusqueda}
              setbusqueda={setbusqueda}
              busqueda={busqueda}
            />
          )
            : panel === "preguntas" ?
              (
                <PreguntasFrecuentes
                  Tema={Tema}
                  setpanel={setpanel}
                  getBusqueda={getBusqueda}
                  setbusqueda={setbusqueda}
                  busqueda={busqueda}
                />
              ) : null
        ) : Error === null ? (
          <div className="loaderContent">
            <Loader type="ThreeDots" color="#0075bb" height={100} width={100} />
          </div>
        )
          : <h1>{Error}</h1>
        }
      </div>
      <Footer />
    </div>
  );
};

const Temas = ({
  temas,
  setTema,
  setpanel,
  getBusqueda,
  busqueda,
  setbusqueda,
}) => {
  const [mensaje, setmensaje] = useState("");
  const [error, seterror] = useState("");
  const [expanded, setExpanded] = React.useState(false);
  let user = JSON.parse(auth.getUsuario());
  const sucursal = useSelector(state => state.page.sucursal);

  const EnviarMensaje = () => {
    let data;
    if (user !== null) {
      data = {
        solicitud: mensaje,
        codigo: user.as400,
        agencia: user.bodega,
        nit: user.nit
      }
    } else {
      data = {
        solicitud: mensaje,
        codigo: "",
        agencia: "",
        nit: ""

      }
    }

    axios
      .post(Constant.ENVIARMENSAJE, data)
      .then((response) => {
        seterror(response.data.message)
      })
      .catch((err) => {
        if (err.response.data.errors) {
          var objkeys = Object.keys(err.response.data.errors)
          seterror(err.response.data.errors[objkeys[0]][0]);
        } else {
          seterror(err.response.data.error);
        }
      });
  }

  return (
    <div className="BodyFrecuentes">
      {temas.map((tema, i) => (
        <div
          key={i}
          className="panel_tema"
          onClick={() => {
            setTema(tema);
            setpanel("preguntas");
          }}
        >
          <div className="content_tema">
            <span>{tema.agrupador}</span>
            <img src={arrowRigth} alt="" />
          </div>
        </div>
      ))}
      <Accordion expanded={expanded} className="panel_tema">
        <AccordionSummary
          onClick={() => setExpanded(!expanded)}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className="content_tema">
            <span>Necesitas más ayuda!</span>
            <img src={expanded ? arrowUp : arrowDown} alt="" />
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="content_mensaje">
            {error !== "" ? <span className="mensaje_api">{error}</span> : null}
            <textarea
              name=""
              value={mensaje}
              id=""
              cols="30"
              rows="10"
              placeholder="Pregúntanos lo que quieras"
              onChange={(e) => {
                if (mensaje.length >= 250) {
                  return;
                }
                setmensaje(e.target.value);
              }}
            ></textarea>
            <span>{mensaje.length} caracteres, 1 mensaje</span>
            <div className="container_send">
              <div className="btn_send" onClick={() => EnviarMensaje()}> <span>Enviar</span></div>
            </div>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const PreguntasFrecuentes = ({
  Tema,
  setpanel,
  getBusqueda,
  busqueda,
  setbusqueda,
}) => {
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => {
    setExpanded(panel === expanded ? false : panel);
  };
  return (<>
    {Tema.preguntas ?
      <div className="BodyFrecuentes">
        {Tema.preguntas.map((tema, i) => (
          <Accordion
            key={i}
            expanded={expanded === "panel" + i}
            className="panel_pregunta"
          >
            <AccordionSummary
              onClick={() => handleChange("panel" + i)}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="content_pregunta">
                <span
                  style={
                    expanded === "panel" + i
                      ? { color: "#0075bb" }
                      : { color: "#5f5e5e" }
                  }
                >
                  {tema.pregunta}
                </span>
                <img
                  src={expanded === "panel" + i ? arrowUp : arrowDown}
                  alt=""
                />
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="content_respuesta">
                <Markup content={tema.respuesta} />
                {tema.imagenes.map((imagen, i) => (
                  <>
                    {imagen.nombreImg ?
                    <img
                      key={i}
                      src={
                        Constant.URL_BASE_IMAGES +
                        "PreguntasFrecuentes/" +
                        tema.id + "/" + imagen.nombreImg
                      }
                      alt=""
                    /> : null}
                  </>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
      : null
    }
  </>
  );
};

export default Contenedor;
